import React, { FC, useCallback, useState, useEffect } from 'react'
import { useField } from 'formik'
import { useTranslations } from 'next-intl'
import { useDebounce } from 'utils/useDebounce'
import { POST_STUDENT_OR_TEACHER_FIELD_NAME, POST_STUDENT_OR_TEACHER_FIELD_PLACEHOLDER } from '../constants'
import { PositionOption } from '../PositionOption/PositionOption'
import { IFormValue } from '../../../validator/IFormValues'
import { CreatableSelectField } from '../../CreatableSelectField/CreatableSelectField'
import style from './RegistartionEducationDirectionField.module.css'
import { FormFieldTypes } from '../../../emun/RegistrationFormFieldTypes'
import { IDictionaryItem } from '../../../interfaces/IDictionaryItem'
import { usePostStudentsOrTeacherFindByName } from '../../../api/query/usePostStudentsOrTeacherFindByName'

const DEFAULT_MIN_SEARCH_LENGTH = 0

const renderItem = (option: IDictionaryItem, inputValue: IDictionaryItem, isActive: boolean) => (
  <PositionOption isActive={isActive} optionName={option.name} inputValue={inputValue.name} />
)

const renderValue = (inputValue: IDictionaryItem) => inputValue.name

type FormEducationDirectionFieldProps = {
  validate?: (name: string) => (currentValue: IFormValue) => Promise<string>
}

export const FormEducationDirectionField: FC<FormEducationDirectionFieldProps> = ({ validate }) => {
  const t = useTranslations()
  const [search, setSearch] = useState('')
  const { data } = usePostStudentsOrTeacherFindByName(DEFAULT_MIN_SEARCH_LENGTH, { searchString: useDebounce(search) })
  const postStudentFieldName = t(POST_STUDENT_OR_TEACHER_FIELD_NAME)
  const postStudentFieldPlaceholder = t(POST_STUDENT_OR_TEACHER_FIELD_PLACEHOLDER)
  const [field] = useField(FormFieldTypes.PostStudentOrTeacher)

  useEffect(() => {
    if (field.value?.id) {
      setSearch(field.value.name)
    }
  }, [field.value?.id])

  const onChange = useCallback((value: string): void => {
    setSearch(value)
  }, [])

  return (
    <CreatableSelectField<IDictionaryItem>
      inputClassName={style.registartionEducationDirectionField}
      name={field.name}
      label={postStudentFieldName}
      options={data}
      onChange={onChange}
      placeholder={postStudentFieldPlaceholder}
      allowCustomValues={false}
      renderItem={renderItem}
      renderValue={renderValue}
      minSearchLength={DEFAULT_MIN_SEARCH_LENGTH}
      validate={validate && validate(field.name)}
    />
  )
}

FormEducationDirectionField.displayName = 'FormEducationDirectionField'
